import BaseHttpService from "./BaseHttpService";
import { IBaseHttpService } from "../types/Http";
import { IBraintreeAuthResponse } from "../types/Payment";
import { ICheckoutStepResponse } from "../types/Checkout";
import { PayPalCheckoutCreatePaymentOptions } from "braintree-web";

export class BraintreeService {
	private _httpService: IBaseHttpService
	private _baseUrl: string;

	/**
	 * @param baseUrl base path for Braintree endpoints. See `BrainTreePayPalController` for
	 * handled endpoints.
	 */
	constructor(baseUrl: string) {
		this._httpService = new BaseHttpService();
		this._baseUrl = baseUrl;
	}


	public async getToken(): Promise<string> {
		const url = this._baseUrl + 'braintree/a/token';
		return await this._httpService.get<string>(url);
	}

	public async getInfo(): Promise<PayPalCheckoutCreatePaymentOptions> {
		const url = this._baseUrl + 'braintree/a/info';
		return await this._httpService.get<PayPalCheckoutCreatePaymentOptions>(url);
	}

	public async handleTransactionApproved(data: IBraintreeAuthResponse): Promise<ICheckoutStepResponse> {
		const url = this._baseUrl + 'braintree/a/approve';
		return await this._httpService.post<ICheckoutStepResponse>(url, data);
	}
}